import { render } from "./IconChat.vue?vue&type=template&id=7259d43d"
import script from "./IconChat.vue?vue&type=script&lang=js"
export * from "./IconChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__